<template>
  <div class="m-2">
    <div id="preloader">
      <div class="jumper">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <div class="sub-header">
      <div class="container">
        <div class="row">
          <div class="col-md-8 col-xs-12">
            <ul class="left-info">
              <li>
                <a href="#"><i class="fa fa-clock"></i>Mon-Fri 09:00-18:00</a>
              </li>
              <li>
                <a href="#"><i class="fa fa-phone"></i>+92 300 8449698</a>
              </li>
            </ul>
          </div>
          <div class="col-md-4">
            <ul class="right-icons">
              <li>
                <a href="#"><i class="fa-brands fa-facebook-f"></i></a>
              </li>
              <li>
                <a href="#"><i class="fa-brands fa-x-twitter"></i></a>
              </li>
              <li>
                <a href="#"><i class="fa-brands fa-linkedin-in"></i></a>
              </li>
              <!-- <li><a href="#"><i class="fa fa-behance"></i></a></li> -->
            </ul>
          </div>
        </div>
      </div>
    </div>
    <header>
      <nav class="navbar navbar-expand-lg">
        <div class="container">
          <router-link class="navbar-brand" to="/">
            <img
              src="./assets/dtech.png"
              alt="Tech Direct Solutions"
              style="width: 10em"
            />
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarResponsive"
            aria-controls="navbarResponsive"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon"></span>
          </button>
          <div class="collapse navbar-collapse" id="navbarResponsive">
            <ul class="navbar-nav ml-auto">
              <li :class="{ 'nav-item': true, active: currentRoute === '/' }">
                <router-link class="nav-link" to="/">Home</router-link>
              </li>
              <li
                :class="{ 'nav-item': true, active: currentRoute === '/about' }"
              >
                <router-link class="nav-link" to="/about">About Us</router-link>
              </li>
              <li
                :class="{
                  'nav-item': true,
                  active: currentRoute === '/services',
                }"
              >
                <router-link class="nav-link" to="/services"
                  >Our Services</router-link
                >
              </li>
              <li
                :class="{
                  'nav-item': true,
                  active: currentRoute === '/contact',
                }"
              >
                <router-link class="nav-link" to="/contact"
                  >Contact Us</router-link
                >
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
    <main>
      <router-view></router-view>
    </main>
    <footer>
      <div class="container">
        <div class="row">
          <div class="col-md-4 footer-item">
            <img
              src="./assets/dtech.png"
              alt="Tech Direct Solutions"
              style="width: 13em; margin: -1em 0 0 -1.3em"
            />
            <p>
              DTECH - Tech Direct Solutions LLP is a business consulting company
              registered with SECP. Our directors bring together a wealth of
              experience in Telecoms, Media, and Technology, specializing in
              Telecoms and ICT sales, ICT solution sales, FTTH network design
              and implementation, as well as satellite solutions, broadcast, and
              digital media.
            </p>
            <!-- <ul class="social-icons">
              <li><a rel="nofollow" href="https://fb.com/templatemo" target="_blank"><i class="fa fa-facebook"></i></a>
              </li>
              <li><a href="#"><i class="fa fa-twitter"></i></a></li>
              <li><a href="#"><i class="fa fa-linkedin"></i></a></li>
              <li><a href="#"><i class="fa fa-behance"></i></a></li>
            </ul> -->
          </div>
          <!-- <div class="col-md-3 footer-item">
            <h4>Useful Links</h4>
            <ul class="menu-list">
              <li><a href="#">Vivamus ut tellus mi</a></li>
              <li><a href="#">Nulla nec cursus elit</a></li>
              <li><a href="#">Vulputate sed nec</a></li>
              <li><a href="#">Cursus augue hasellus</a></li>
              <li><a href="#">Lacinia ac sapien</a></li>
            </ul>
          </div> -->
          <div class="col-md-3 footer-item">
            <h4>Additional Pages</h4>
            <ul class="menu-list">
              <li><router-link to="/about" href="#">About Us</router-link></li>
              <li><router-link to="/services" href="#">How We Work</router-link></li>
              <!-- <li><router-link to="/contact" href="#">Quick Support</router-link></li> -->
              <li><router-link to="/contact"  href="#">Contact Us</router-link></li>
              <!-- <li><router-link href="#">Privacy Policy</router-link></li> -->
            </ul>
          </div>
          <div class="col-md-5 footer-item last-item">
            <h4>Contact Us</h4>
            <div class="contact-form">
              <form id="contact footer-contact" ref="form" @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <fieldset>
                      <input
                        name="from_name"
                        type="text"
                        class="form-control"
                        id="name"
                        placeholder="Full Name"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <div class="col-lg-12 col-md-12 col-sm-12">
                    <fieldset>
                      <input
                        name="email"
                        type="text"
                        class="form-control"
                        id="email"
                        pattern="[^ @]*@[^ @]*"
                        placeholder="E-Mail Address"
                        required=""
                      />
                    </fieldset>
                  </div>
                  <div class="col-lg-12">
                    <fieldset>
                      <textarea
                        name="message"
                        rows="6"
                        class="form-control"
                        id="message"
                        placeholder="Your Message"
                        required=""
                      ></textarea>
                    </fieldset>
                  </div>
                  <div class="col-lg-12">
                    <div class="d-flex justify-content-between">
                      <div>
                        <button
                          type="submit"
                          id="form-submit"
                          class="filled-button"
                        >
                          Send Message
                        </button>
                      </div>
                      <div
                        v-if="showMessage"
                        class="alert w-50 p-2"
                        :class="{ 'alert-primary': !formError, 'alert-danger': formError }"
                      >
                        {{ resultMessage }}
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </footer>

    <div class="sub-footer">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <p>Copyright &copy; 2024 Tech Direct Solutions LLP</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/main.css";
import fromMixin from "./mixins/fromMixin";
export default {
  name: "App",
  mixins: [fromMixin],
  computed: {
    currentRoute() {
      return this.$route.path;
    },
  },
};
</script>
